import { Row, Col } from "react-bootstrap";
import { APP_CONFIG } from "config/appConfig";
import { ColorPicker, UnitPicker } from "..";

export type LDSUDevice = {
    ldsu_uuid: string;
    SAID: number;
    device_name: string;
    sensor_type: string;
    unit: string;
    gatewayId: string;
    color: string;
    cls: string;
    app: string;
    appId: string;
    isActuator: boolean;
};

type LDSUWidgetSensorListProps = {
    sensors: LDSUDevice[];
    onColorChange: (sensor: LDSUDevice, color: string) => void;
};

export const LDSUWidgetSensorList = ({
    sensors,
    onColorChange,
}: LDSUWidgetSensorListProps) => {
    const ldsuDisplayName = APP_CONFIG.APP_IS_ONPREM
        ? "LDSU/Auxiliary Hub"
        : "LDSU";

    if (sensors.length === 0) {
        return <></>;
    }

    return (
        <div>
            <div className="mb-2">
                {`Sensors on this ${ldsuDisplayName}`}
            </div>
            <div className="cstm-table w-100 px-2">
                <Row className="d-none d-md-flex table-head px-2">
                    <Col md={4}>Sensor</Col>
                    <Col md={4}>Type</Col>
                    <Col md={2}>Unit</Col>
                    <Col>Color</Col>
                </Row>

                {sensors.map((sensor: LDSUDevice, index: number) => (
                    <Row
                        key={`${sensor.ldsu_uuid}-${sensor.SAID}-${index}`}
                        className="bg-secondary px-2 py-2 mb-2 align-items-center rounded w-100"
                    >
                        <Col md={4}>{sensor.device_name || "-"}</Col>
                        <Col md={4}>{sensor.sensor_type || "-"}</Col>
                        <Col md={2}>
                            <UnitPicker
                                data={
                                    [sensor.unit]
                                }
                                defaultValue={sensor.unit}
                            />
                        </Col>
                        <Col>
                            <ColorPicker
                                defaultValue={sensor.color}
                                onChange={(_event: any, color: string) =>
                                    onColorChange(sensor, color)
                                }
                            />
                        </Col>
                    </Row>
                ))}
            </div>
        </div>
    );
};
